export const districtTypesMatch = (source = [], target = []) => {
  const sourceTypes = [...new Set(source)].sort();
  const targetTypes = [...new Set(target)].sort();
  return sourceTypes.length === targetTypes.length
    && sourceTypes.every((type, index) => type === targetTypes[index]);
};
